import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../userContext/UserContext';

const PrivateRoute = ({ children }) => {
    const { isAuthenticated, loading } = useContext(UserContext);

    // Show a loading state while authentication is being initialized
    if (loading) {
        return <div>Loading...</div>;
    }

    // Redirect to /signin if not authenticated
    return isAuthenticated ? children : <Navigate to="/signin" />;
};

export default PrivateRoute;
